import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheckCircle, faExclamationTriangle, faInfoCircle } from "@fortawesome/free-solid-svg-icons";

import List from "./components/list";

const NotificationListBar = (props) => {
    let cssClass = "notification-bar";
    let icon;
    switch (props.type) {
        case "error":
            cssClass += " -error";
            icon = <FontAwesomeIcon icon={faExclamationTriangle} />;
            break;
        case "warning":
            cssClass += " -warning";
            icon = <FontAwesomeIcon icon={faExclamationTriangle} />;
            break;
        case "success":
            cssClass += " -success";
            icon = <FontAwesomeIcon icon={faCheckCircle} />;
            break;
        default:
            cssClass += " -info";
            icon = <FontAwesomeIcon icon={faInfoCircle} />;
    }
    const link = props.link ? (
        <a href={props.link} target="_blank" rel="noopener noreferrer">
            {props.linkText}
        </a>
    ) : null;

    return (
        <div className={cssClass}>
            <div>
                <strong>
                    {props.message} {link}
                </strong>
                <List list={props.list} />
            </div>
            <div className="icon">{icon}</div>
        </div>
    );
};

NotificationListBar.defaultProps = {
    message: "",
    type: "info",
};

export default NotificationListBar;
